import { packages } from "../../constants/appConstats";
import {
  chooseYourAventureLabel,
  ourExperiencesLabel,
  packageDescriptionLabel,
} from "../../constants/translations";
import "../componentsStyle.scss";
import { PackageCard } from "./PackageCard";

export const PackageContainer = ({ languageId }) => {
  return (
    <div className="packageContainer" id="packages">
      <div className="lable">{ourExperiencesLabel[languageId]?.label}</div>
      <div className="title">{chooseYourAventureLabel[languageId]?.label}</div>
      <div className="description">
        {packageDescriptionLabel[languageId]?.label}
      </div>

      <div className="packages">
        {packages?.map((packageItem) => (
          <PackageCard
            key={packageItem.id}
            packageItem={packageItem}
            languageId={languageId}
          />
        ))}
      </div>
    </div>
  );
};
